import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ 'filtersForm' ]

  submit() {
    this.filtersFormTarget.requestSubmit()

    const frame = document.getElementById(this.filtersFormTarget.dataset.turboFrame)
    frame?.addEventListener('turbo:frame-load', this.updateResultsCount, { once: true })
  }

  updateResultsCount = (event) => {
    const badge = document.getElementById('results-count')
    const meta = event.target.querySelector('[data-results-count-text]')

    if (badge && meta) {
      badge.textContent = meta.dataset.resultsCountText
    }
  }
}
